import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useRef, useState } from "react";
import { deleteNotes, addNewNote, editNote } from "../../../../service/api";

function Children({ childrenNote, farmerId }) {
  const queryClient = useQueryClient();
  const [textValue, setTextValue] = useState("");
  const mutation = useMutation(deleteNotes, {
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["farmerInfo"] }),
  });
  const addNewNoteMutation = useMutation(addNewNote, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["farmerInfo"] });
      setTextValue("");
    },
  });
  const editNoteMutation = useMutation(editNote, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["farmerInfo"] });
    },
  });
  const [showText, setShowText] = useState(true);
  const [showBtn, setShowBtn] = useState(true);
  const [editValue, setEditValue] = useState("");
  // const [showEditConfirm, setShowEditConfirm] = useState(true);
  
  const notesRef = useRef([]);
  const [buttonStatus, setButtonStatus] = useState({})

  const handelCancel = () => {
    setShowBtn(true);
    setTextValue("");
    setShowText(true);
  };

  const handelChange = (value) => {
    setShowBtn(false);
    setTextValue(value);
  };

  // event:(res) => {
  //   editNoteMutation.mutate({
  //     farmerId: farmerId,
  //     id: res.id,
  //     note: editValue,
  //   })},

  const handelEdit = (value, i) => {
    setEditValue(value);
    setButtonStatus({
      id: i,
      status: 'EDITING'
      })
  };

  const addNewHandler = () => {
    addNewNoteMutation.mutate({
      farmerId: farmerId,
      note: textValue,
    });
    setShowText(true);
    setTextValue("");
  };


  return (
    <div className="flex flex-col gap-4">
      <section className="flex flex-row max-lg:flex-row-reverse justify-between items-center ">
        <p className="max-lg:text-[0.5625rem] max-lg:font-semibold ">
          یادداشت‌های مربوط به کشاورز{" "}
        </p>
        <Button
          onClick={() => setShowText(false)}
          className="bg-gradient-to-r from-blue-800 to-sky-600 text-white max-lg:text-[0.5625rem]"
          icon={<PlusSquareOutlined />}
        >
          افزودن یادداشت
        </Button>
      </section>
      <Form hidden={showText}>
        <section className="flex flex-col gap-3">
          <Form.Item name={"text"}>
            <TextArea
              value={textValue}
              hidden={showText}
              id="textArea"
              // ref={textRef}
              onChange={(e) => handelChange(e.target.value)}
            />
            <div className="flex flex-row h-fit justify-end pt-2 gap-5 ">
              
                <Button
                danger
                  className="!bg-[#B8083D] max-lg:text-[0.5625rem]"
                  hidden={showBtn}
                  type="primary"
                  onClick={() => handelCancel()}
                  icon={<CloseOutlined />}
                >
                  لغو
                </Button>
                <Button
                  htmlType="submit"
                  onClick={addNewHandler}
                  hidden={showBtn}
                  type="primary"
                  className="bg-gradient-to-r from-blue-800 to-sky-600 text-white max-lg:text-[0.5625rem] "
                  icon={<CheckOutlined />}
                >
                  ثبت
                </Button>
             
            </div>
          </Form.Item>
        </section>
      </Form>
      {childrenNote.map((res, i) => {
        return (
          <>
            <section >
              <Form>
                <section className="flex flex-col gap-3">
                  <Form.Item name={"text"}>
                    <TextArea
                      ref={ref=>notesRef.current[i] = ref}
                      key={res?.note}
                      id={i}
                      defaultValue={res?.note}
                      onChange={(e) => handelEdit(e.target.value, i)}
                    />
                    <div className="flex flex-row justify-end pt-2 gap-3 ">
                      <Button
                      danger
                        className=" !bg-[#B8083D] max-lg:text-[0.5625rem]"
                        type="primary"
                        onClick={() =>
                          mutation.mutate({ farmerId: farmerId, id: res.id })
                        }
                        icon={<CloseOutlined />}
                      >
                        حذف{" "}
                      </Button>
                      {/* <Button
                        hidden={showEditConfirm}
                        onClick={() => {
                          editNoteMutation.mutate({
                            farmerId: farmerId,
                            id: res.id,
                            note: editValue,
                          });
                          setShowEditBtn(false);
                          setShowEditConfirm(true);
                        }}
                        htmlType="submit"
                        key={notesRef.current[i]}
                        type="primary"
                        className="bg-gradient-to-r from-blue-800 to-sky-600 text-white max-lg:text-[0.5625rem] "
                        icon={<CheckOutlined />}
                      >
                        اعمال تغییرات{" "}
                      </Button> */}
                      <Button
                        onClick={(buttonStatus?.status === 'EDITING' && buttonStatus?.id === i) ? ()=> { editNoteMutation.mutate({farmerId: farmerId, id: res.id, note: editValue,})
                         setButtonStatus({id:-1})} : () => {notesRef.current[i].focus()}}
                        htmlType="submit"
                        type="primary"
                        key={notesRef.current[i]}
                        className="bg-gradient-to-r from-blue-800 to-sky-600 text-white max-lg:text-[0.5625rem] "
                        icon={<EditOutlined />}
                      >{(buttonStatus?.status === 'EDITING' && buttonStatus?.id === i) ? 'اعمال تغییرات' : 'ویرایش'}</Button>
                    </div>
                  </Form.Item>
                </section>
              </Form>
            </section>
          </>
        );
      })}
    </div>
  );
}

export default Children;
